import {announce} from '@aboutyou/a11y';
import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {Session} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/session.types';
import {BasketPageService_RemoveItemLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.grpc.lazy';
import {ChangeQuantityResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {useFullSession} from '@aboutyou/user';
import {useCallback} from 'react';
import {useReductionsStateRequestParameterCallback} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useUpdateBasketSectionsCallback} from './useUpdateBasketSections';

export const useDeleteHandler = () => {
  const session = useFullSession() as Session;
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const {t} = useTranslation();

  const updatePageBulkSections = useUpdateBasketSectionsCallback();

  const getReductionsState = useReductionsStateRequestParameterCallback();

  const deleteItemCallback = useGrpcRequestMutation(
    BasketPageService_RemoveItemLazy,
    {
      onSuccess: (data: ChangeQuantityResponse) => {
        updatePageBulkSections(data.sections);
      },
    },
  );

  return useCallback(
    async (itemKey: string) => {
      try {
        const result = await deleteItemCallback.mutateAsync({
          session,
          itemKey,
          targetGroup: targetGroupIdentifier,
          reductionsState: await getReductionsState(),
        });

        announce(t('Item removed from basket'), 'polite');

        return result;
      } catch (error) {
        announce(
          t('Could not remove the item from your basket. Please try again.'),
          'assertive',
        );

        throw error;
      }
    },
    [deleteItemCallback, getReductionsState, t],
  );
};
